import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../utils/Customer/apiBaseQuery";
import {
  CREATE_PET,
  GET_ALL_PETS,
  GET_PET_BY_PET_ID,
  UPDATE_PET,
  UPDATE_PET_STATUS,
} from "../../../config/apiUrlsAdmin";
import {
  ICreatePetRequest,
  IPetFilterRequest,
  IUpdatePetStatusRequest,
} from "../../../types/Request/AdminRequest";
import { IGetPetResponse } from "../../../types/Response/AdminResponse";

export const adminPetsAPi = createApi({
  reducerPath: "adminPetsAPi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Pets"], // Add this tag type
  endpoints: (builder) => ({
    CreatePet: builder.mutation<boolean, ICreatePetRequest>({
      query: (data) => ({
        url: CREATE_PET,
        method: "post",
        data: data,
      }),
      invalidatesTags: ["Pets"], // Invalidates cache to trigger refetch
    }),
    UpdatePet: builder.mutation<boolean, ICreatePetRequest>({
      query: (data) => ({
        url: UPDATE_PET,
        method: "put",
        data: data,
      }),
      invalidatesTags: ["Pets"], // Invalidates cache to trigger refetch
    }),

    UpdatePetStatus: builder.mutation<boolean, IUpdatePetStatusRequest>({
      query: (data) => ({
        url: UPDATE_PET_STATUS,
        method: "patch",
        data: data,
      }),
      invalidatesTags: ["Pets"], // Invalidates cache to trigger refetch
    }),
    GetPetsById: builder.query<IGetPetResponse, number>({
      query: (id) => ({
        url: `${GET_PET_BY_PET_ID}/${id}`,
        method: "get",
      }),
      providesTags: ["Pets"], // Listens for invalidations
    }),
    GetAllPets: builder.query<IGetPetResponse[], IPetFilterRequest>({
      query: (payload) => ({
        url: GET_ALL_PETS,
        method: "get",
        data: payload,
      }),
      providesTags: ["Pets"], // Listens for invalidations
    }),
  }),
});

export const {
  useCreatePetMutation,
  useUpdatePetMutation,
  useLazyGetAllPetsQuery,
  useLazyGetPetsByIdQuery,
  useUpdatePetStatusMutation
} = adminPetsAPi;
